

































import {
  Component,
  Vue,
  Watch,
} from 'vue-property-decorator';

import bImg from 'bootstrap-vue/es/components/image/img';

import {
  Image,
  ImageTag,
} from '@/models';

import Carousel from '@/components/Carousel.vue';
import CarouselSlide from '@/components/CarouselSlide.vue';

const ImageCarouselViewProps = Vue.extend({
  props: {
    images: {
      type: Array as () => Image[],
      required: true,
    },
  },
});

@Component({
  components: {
    Carousel,
    CarouselSlide,
    bImg,
  },
})
export default class ImageCarouselView extends ImageCarouselViewProps {
  private focusedImage: Image | null = null;

  public mounted() {
    this.onImagesChanged();
  }

  @Watch('images')
  public onImagesChanged() {
    // Show the first image.
    if (this.images && this.images.length > 0) {
      this.showImage(this.images[0]);
    }
  }

  public showImage(image: Image) {
    // Show the image.
    this.focusedImage = image;
  }
}

